<template>
	<div class="import-log">
		<div>
			<multi-table ref="multiTable" :page="pageInfo" :columns="columns" @gePartnerList="tabGetList" :list="list" :total="total" v-loading="loading">
				<empty ref="empty" slot="empty"></empty>
			</multi-table>
		</div>
	</div>
</template>

<script>
import { platformMixin } from '@rd/rd-ui';
import { mapGetters } from 'vuex';
import { importRecords } from '@/api/sampleOrder';
import getColums from './columns';
export default {
	name: 'importLog',
	components: {
		
	},
	mixins: [platformMixin],
	data() {
		return {
			list: [],
			pageInfo: {
				page_index: 1,
				page_size: 10,
			},
			total: 0,
			loading: false,
		};
	},
	computed: {
		...mapGetters(['defaultPlatform']),
		columns() {
			return getColums(this);
		},
	},
	created() {
		this.getList();
	},
	methods: {
		taskStatus(row) {
			const taskStatusMap = new Map([
				[0, '上传中'],
				[1, '上传成功'],
				[2, '上传失败'],
				[3, '上传中'],
			]);
			return +row.task_status === 3 && +row.fail_count > 0 ? '部分失败' : taskStatusMap.get(+row.task_status);
		},
		// sizeChange(size) {
		// 	this.pageInfo.page_size = size;
		// 	this.getList();
		// },
		// currentChange(index) {
		// 	this.pageInfo.page_index = index;
		// 	this.getList();
		// },
		tabGetList(val) {
			this.pageInfo.page_index = val.page_index;
			this.pageInfo.page_size = val.page_size;
			this.getList();
		},
		async getList() {
			try {
				this.loading = true;
				const { code, data: { list = [], page = {} } = {} } = await importRecords(this.pageInfo);
				if (code !== 0) return;
				this.list = list;
				this.total = page.item_total;
			} finally {
				this.loading = false;
			}
		},
	},
};
</script>

<style lang="less" scoped>
.import-log {
	.success {
		color: @color-g;
	}
	.error {
		color: @color-r;
	}
	.tag {
		display: flex;
		align-items: center;
		&::before {
			content: '';
			width: 6px;
			height: 6px;
			border-radius: 50%;
			margin-right: 8px;
		}
		&.error-tag::before {
			background-color: @color-r;
		}
		&.loading-tag::before {
			background-color: @color-o;
		}
		&.success-tag::before {
			background-color: @color-g;
		}
	}
}
</style>
